// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"3cd904aa","31":"2e27b124","76":"2d8368f1","320":"5646e9bc","361":"981a2289","492":"d94fc3b0","582":"3d68675a","842":"932660f1"}[chunkId] + ".chunk.js";
};